import React, { useCallback, useEffect, useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
// import { RoutePath } from '../../../routes/Routes'
import StateComponents from '../../../../components/state-component/StateComponents'
import { Box, Collapse, IconButton, ImageList, ImageListItem, List, ListItemButton, ListItemIcon, ListItemText, Typography, useTheme } from '@mui/material'
import ContainerButton from '../../../../components/button/ContainerButton'
import { BoxFolder } from '../../media/style/StyleMedia'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'
import { listMedia, MediaApi, mediaTypeData } from '../../../../api/media-file/MediaFile.api'
import { useDispatch, useSelector } from 'react-redux'
import { checkPermission, getBaseApi } from '../../../../utils/app.utils'
import { IconComponents, icons } from '../../../../assets/icons/icons'
import { colors } from '../../../../constants/colors'
// import { motion } from 'framer-motion'
import CheckBoxCustom from '../../../../components/checkbox/CheckBoxCustom'
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal'
import ModalCustom from '../../../../components/modal/modalCustomCms'
import CloseIcon from '@mui/icons-material/Close';
import { TransitionGroup } from "react-transition-group";
import clsx from 'clsx'
// import Draggable from 'react-draggable';
import { flattenMenu } from '../../website-structure/menu/util'
import { FolderTree } from '../../../../components/folder-tree/FolderTree'
import { useInView } from 'react-intersection-observer'
import { routeName } from '../../../../routes/routeName'
import MovieIcon from '@mui/icons-material/Movie';
import { RootState } from '../../../../store/store'
import { useTranslation } from 'react-i18next'

type Props = {}
// const containerVariants = {
//     hidden: {},
//     show: {
//         transition: {
//             staggerChildren: 0.15,
//         },
//     },
// };

// const itemVariants = {
//     hidden: { opacity: 0, x: -30 },
//     show: (i: number) => ({
//         opacity: 1,
//         x: 0,
//         transition: {
//             delay: i * 0.1,
//             duration: 0.5,
//             ease: "easeOut",
//         },
//     }),
// };

export const MasonryImageList = (
    itemData: { id_media_file: number, img: string, title?: string }[],
    loadedMap: Record<string, boolean>,
    setLoadedMap: React.Dispatch<React.SetStateAction<Record<string, boolean>>>,
    checked: number[],
    handleChangeSelected: (id_media_file: number) => void,
) => {
    const theme = useTheme();
    const is_md = theme.breakpoints.down('md');
    // console.log(itemData, 'itemData')
    return (
        <Box sx={{ width: '100%', minHeight: 500 }}>
            <ImageList variant="masonry" cols={is_md ? 2 : 3} gap={8}>
                {itemData.map((list) => {
                    const isLoaded = loadedMap[list?.id_media_file];
                    const is_mp4 = String(list.img).includes('.mp4');
                    return (
                        <div onClick={() => handleChangeSelected(list.id_media_file)} className='flex relative w-full justify-center items-center flex-wrap max-w-[auto]'>
                            {(isLoaded || is_mp4) && (
                                <span className='flex z-10 text-white justify-center items-center rounded-md absolute top-2 right-4'>
                                    <CheckBoxCustom
                                        checked={checked.includes(list?.id_media_file)}
                                        setChecked={() => handleChangeSelected(list?.id_media_file)}
                                    />
                                </span>
                            )}
                            <ImageListItem key={list.img}>
                                {is_mp4 ? (
                                    <Box className="cursor-pointer" width={248} height={248}>
                                        <MovieIcon sx={{ fontSize: 248 }} />
                                        <Typography textAlign={'center'} noWrap>{list.title}</Typography>
                                    </Box>
                                ) : (
                                    <img
                                        onLoad={() =>
                                            setLoadedMap?.((prev) => ({ ...prev, [list?.id_media_file]: true }))
                                        }
                                        loading='lazy'
                                        className={`object-contain hover:opacity-45 cursor-pointer duration-500 ${isLoaded ? 'blur-0 opacity-100' : 'blur-md opacity-30'
                                            } transition-all`}
                                        srcSet={`${list.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                                        src={`${list.img}?w=248&fit=crop&auto=format`}
                                        alt={list.title}
                                    />
                                )}
                            </ImageListItem>
                        </div>
                    )
                })}
            </ImageList>
        </Box>
    );
}
export function markTotalFileCounts(node: any): any[] {
    const children = (node.children || []).map(markTotalFileCounts);
    const total = (node.file_count || 0) + children.reduce((acc: number, c: any) => acc + c.total_file_count, 0);
    return {
        ...node,
        children,
        total_file_count: total
    };
}

const ManageFile: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();

    // const profileReducer = useSelector((state: RootState) => state.profile.profile);
    // const permission: any[] = profileReducer?.permission || [];
    // const checkPermit = checkPermission('setting_manage_country', permission);

    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('WEBSITE_STRUCTURE_MANAGE_FILE', permission);

    const base_image_url = getBaseApi()
    const dispatch = useDispatch();
    const [treeListData, setTreeListData] = useState<any[]>([]);
    const [id_media, set_id_media] = useState<number | null>(null);
    const [media_files, set_media_files] = useState<any[]>([]);
    const [media_files_local, set_media_files_local] = useState<any[]>([]);
    const [loadedMap, setLoadedMap] = useState<Record<string, boolean>>({});
    const [checked, setChecked] = useState<number[]>([]);
    const [showModal, setShowModal] = useState<string>("");
    const [keyword, set_keyword] = useState<string>("");
    const [submit_keyword, set_submit_keyword] = useState<string>("");
    const [all_folder, set_all_folder] = useState<any[]>([]);
    const [formState, setFormState] = useState<mediaTypeData>({
        id_media_ref: null,
        media_name: ""
    })

    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });

    const [id_media_data, set_id_media_data] = useState<number[]>([]);
    // const [selected_id_media, set_selected_media] = useState<number | null>(null);


    const handleCloseModal = () => {
        setShowModal("");
        setFormState({
            id_media_ref: null,
            media_name: ""
        })
    }

    const handleChangeSelected = (id_media_file: number) => {
        if (checked?.some((x) => x === id_media_file)) {
            setChecked((prev) => prev.filter((x) => x !== id_media_file))
        } else {
            setChecked((prev) => ([...prev, id_media_file]))
        }
    }

    const handleOpenMedia = (id_media_value: number) => {
        if (id_media_value === id_media) {
            set_id_media(null);
        }
        const has_id: boolean = id_media_data.some((x) => x === id_media_value);
        if (has_id) {
            set_id_media_data((prev) => prev?.filter((x) => id_media_value !== x))
        } else {
            set_id_media_data((prev) => ([...prev, id_media_value]))
        }
    }

    const handleGetMediaFile = async (id_media_value: number) => {
        dispatch(setLoading());
        await MediaApi.getMediaFile(id_media_value).then((res) => {
            if (res.status < 300) {
                const media_files_data = res.data?.data?.media_files;
                set_media_files(media_files_data || [])
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleGetTreeList = useCallback(async () => {
        dispatch(setLoading());
        let query: listMedia = {}
        if (submit_keyword) query = { ...query, keyword: submit_keyword }
        await MediaApi.treeList(query).then((res) => {
            if (res.status < 300) {
                const data = res.data?.data?.map(markTotalFileCounts) || []
                const all_folder = flattenMenu(data);
                set_all_folder(all_folder || []);
                setTreeListData(data)

            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [submit_keyword])

    const handleDeleteMediaFile = () => {
        alertActive(t("ลบไฟล์"), t("ต้องการลบไฟล์ในรายการที่เลือก?"), undefined, undefined, async () => {
            const id_media_files: number[] = media_files?.filter((x) => checked?.includes(x?.id_media_file)).map((list) => list?.id_media_file)
            if (id_media_files.length > 0) {
                dispatch(setLoading())
                const promise_deleted = id_media_files?.map(async (id) => {
                    await MediaApi.deleteFile(id);
                })
                await Promise.all(promise_deleted);
                alertSuccess(t("ลบไฟล์"), t("ลบไฟล์เรียบร้อยแล้ว"));
                dispatch(unsetLoading());
                handleGetTreeList();
                if (id_media) {
                    handleGetMediaFile(id_media);
                }
            }
        })
    }

    const handleGetDetailMedia = (id_media: number) => {
        set_id_media(id_media);
        handleGetMediaFile(id_media);
    }
    const handleDeleteMediaFolder = () => {
        if (id_media) {
            alertActive(t("ลบ Folder"), t("ต้องการลบ Folder ที่เลือก?"), undefined, undefined, async () => {
                dispatch(setLoading());
                await MediaApi.deleteFolder(id_media).then((res) => {
                    if (res.status < 300) {
                        handleGetTreeList();
                        alertSuccess(t("ลบโฟลเดอร์"), t("ลบโฟลเดอร์เรียบร้อยแล้ว"));
                    }
                }).catch((err) => {
                    console.log(err)
                }).finally(() => {
                    dispatch(unsetLoading())
                })
            })
        }
    }

    const handleSubmitKeyword = () => {
        set_submit_keyword(keyword)
    }

    const handleChangeFileLocal = (file: File[]) => {
        set_media_files_local((prev) => ([...prev, ...file]))
    }
    const handleDeleteFileLocal = (index: number) => {
        set_media_files_local((prev) => prev.filter((_, i) => i !== index))
    }
    const handleEditMediaFolder = () => {
        setShowModal("EDIT");
        const data_folder = all_folder?.find((x) => x?.id_media === id_media);
        if (data_folder) {
            setFormState((prev) => ({
                ...prev,
                media_name: data_folder?.media_name,
                id_media_ref: data_folder?.id_media_ref
            }))
        }
    }

    const handleSubmitFileLocal = async () => {
        if (media_files_local?.length === 0) {
            return alertError(t("เลือกไฟล์ก่อนบันทึกข้อมูล"));
        }
        if (media_files_local?.length > 0 && id_media) {
            dispatch(setLoading());
            const promise_file = media_files_local?.map(async (list) => {
                const formData = new FormData();
                formData.append('files', list)
                await MediaApi.createFile(id_media, formData).catch((err) => console.log(err))
            })
            await Promise.all(promise_file);
            dispatch(unsetLoading());
            handleGetMediaFile(id_media);
            set_media_files_local([]);
            handleGetTreeList();
            alertSuccess(t("อัพโหลดไฟล์"), t("อัพโหลดไฟล์เรียบร้อย"));
        }
    }

    const handleSubmitMedia = async (id_media?: number) => {
        dispatch(setLoading());
        if (id_media && showModal === 'EDIT') {
            await MediaApi.updateMedia(id_media, formState).then((res) => {
                if (res.status < 300) {
                    handleGetTreeList();
                    handleCloseModal();
                    alertSuccess(t("อัพเดตโฟลเดอร์"), t("อัพเดตโฟลเดอร์ เรียบร้อย"));
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("อัพเดตโฟลเดอร์"), t("อัพเดตโฟลเดอร์ ไม่สำเร็จ"));
            })
        } else {
            await MediaApi.createMedia(formState).then((res) => {
                if (res.status < 300) {
                    handleGetTreeList();
                    handleCloseModal();
                    alertSuccess(t("เพิ่มโฟลเดอร์"), t("เพิ่มโฟลเดอร์ เรียบร้อย"));
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("เพิ่มโฟลเดอร์"), t("เพิ่มโฟลเดอร์ ไม่สำเร็จ"));
            })
        }
    }



    useEffect(() => {
        handleGetTreeList();
    }, [handleGetTreeList])




    const renderFile = (subMedia: any[], pl: number): React.ReactNode => {
        return (
            <List component="div" disablePadding>
                {subMedia.map((media: any, index: number) => {
                    return (
                        <>
                            <ListItemButton className='flex justify-between items-center' key={media?.id_menu + index} sx={{ ml: pl }} onClick={() => {
                                handleGetDetailMedia(media?.id_media);
                                handleOpenMedia(media?.id_media);
                            }}>
                                <span className='flex flex-1 w-full'>
                                    <ListItemIcon>
                                        <ArrowForwardIosIcon sx={{
                                            fontSize: "16px",
                                            transform: (id_media_data?.includes(media?.id_media) && media?.children?.length) > 0 ? "rotate(90deg)" : "",
                                            transition: "all .5s ease"
                                        }} className={clsx('', {
                                            'text-active_color': id_media === media?.id_media
                                        })} />
                                        {id_media === media?.id_media ? (
                                            <IconComponents.FolderActive />
                                        ) : (
                                            <IconComponents.FolderInActive />
                                        )}
                                    </ListItemIcon>
                                    <ListItemText className={clsx('', {
                                        'text-active_color': id_media === media?.id_media
                                    })} primary={media?.media_name} />
                                </span>
                                <span className='flex-1 flex items-center justify-end'>
                                    <Typography>
                                        {media?.total_file_count || "0"}
                                    </Typography>
                                </span>
                            </ListItemButton>
                            {media?.children?.length > 0 && (
                                <div className='w-full'>
                                    <TransitionGroup >
                                        {id_media_data?.includes(media?.id_media) && (
                                            <Collapse timeout="auto" unmountOnExit>
                                                {renderFile(media?.children, pl + 2)}
                                            </Collapse>
                                        )}
                                    </TransitionGroup>
                                </div>
                            )}
                        </>
                    )
                })}
            </List>
        )
    }

    return (
        <ContainerLayout
            title=''
            titleName={t('จัดการไฟล์')}
            navigateContent={
                <NavigateListCustom
                    navigateData={
                        [
                            {
                                key: "ตั้งค่า", // i18n-ignore
                                name: t("ตั้งค่า"),
                                pathName: "",
                                disabled_match: true
                            },
                            {
                                key: "จัดการไฟล์", // i18n-ignore
                                name: t("จัดการไฟล์"),
                                pathName: routeName.cms_website.setting_manage_file,
                            },
                        ]}
                />
            }
            content={
                <>
                    <div className='w-full flex flex-col lg:flex-row gap-4'>
                        <div className='w-full h-fit flex flex-col rounded-lg border-2 border-[#DDE1EB]'>
                            <span className='flex-1 w-full p-4'>
                                <Typography mt={2} mb={2} variant='h5'>
                                    {t("โฟลเดอร์")}
                                </Typography>
                                <div className='flex flex-col gap-2'>
                                    {treeListData?.length === 0 && (
                                        <span className='text-[#828282]'>
                                            {t("ไม่พบข้อมูล...")}
                                        </span>
                                    )}
                                    {treeListData?.map((list, index) => {
                                        return (
                                            <>
                                                <BoxFolder id={`box-b-${index}`} onClick={() => {
                                                    set_id_media(list?.id_media);
                                                    setFormState((prev) => ({ ...prev, id_media_ref: list?.id_media }))
                                                    handleGetMediaFile(list?.id_media);
                                                    handleOpenMedia(list?.id_media);
                                                    // onSelectMediaFile?.(list.id_media, null);
                                                }} key={index} className='w-full flex justify-between'>
                                                    <span className='flex justify-start items-center gap-2'>
                                                        <ArrowForwardIosIcon
                                                            sx={{
                                                                fontSize: "16px",
                                                                color: id_media === list?.id_media ? colors.themeMainColorTwo : undefined
                                                            }}
                                                        />
                                                        {id_media === list?.id_media ? (
                                                            <IconComponents.FolderActive />
                                                        ) : (
                                                            <IconComponents.FolderInActive />
                                                        )}
                                                        {list.media_name || "-"}
                                                    </span>
                                                    <span>
                                                        <Typography>
                                                            {list?.total_file_count || "0"}
                                                        </Typography>
                                                    </span>
                                                </BoxFolder>
                                                {list?.children?.length > 0 && (
                                                    <div className='w-full'>
                                                        <TransitionGroup >
                                                            {id_media_data?.includes(list?.id_media) && (
                                                                <Collapse timeout="auto" unmountOnExit>
                                                                    {renderFile(list?.children, 3)}
                                                                </Collapse>
                                                            )}
                                                        </TransitionGroup>
                                                    </div>
                                                )}
                                            </>
                                        )
                                    })}
                                </div>

                            </span>
                            <span className='w-full flex flex-col gap-4 p-4 bg-[#F2F4F7]'>
                                <StateComponents
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            fieldProps: {
                                                onChange: (e) => set_keyword(e.target.value),
                                                placeholder: t("ค้นหา"),
                                                endAdornment: (
                                                    <ContainerButton
                                                        sxContainer={{ maxWidth: 100 }}
                                                        justifyContent='flex-end'
                                                        buttonData={[
                                                            {
                                                                seq: 1,
                                                                buttonProps: {
                                                                    onClick: () => handleSubmitKeyword()
                                                                },
                                                                key: "SEARCH",
                                                                label: t("ค้นหา"),
                                                                type: "SEARCH"
                                                            }
                                                        ]}
                                                    />
                                                )
                                            }
                                        }
                                    ]}
                                />

                                <ContainerButton
                                    justifyContent='center'
                                    buttonData={[
                                        {
                                            seq: 1,
                                            key: "ADD",
                                            label: t("เพิ่ม"),
                                            hidden: !checkPermit.isCreated,
                                            buttonProps: {
                                                onClick: () => setShowModal("ADD"),
                                            },
                                            type: "ADD2"
                                        },
                                        {
                                            seq: 3,
                                            key: "EDIT",
                                            // hidden: (id_media == 2 || id_media == 2),
                                            hidden: (id_media == 2 || id_media == 2) || !checkPermit.isUpdate,
                                            label: t("แก้ไข"),
                                            buttonProps: {
                                                disabled: !id_media,
                                                onClick: handleEditMediaFolder
                                            },
                                            type: "EDIT"
                                        },
                                        {
                                            seq: 4,
                                            key: "DELETE_BIN",
                                            label: t("ลบ"),
                                            // hidden: (id_media == 2 || id_media == 2),
                                            hidden: (id_media == 2 || id_media == 2) || !checkPermit.isDelete,
                                            buttonProps: {
                                                disabled: !id_media,
                                                onClick: () => handleDeleteMediaFolder()
                                            },
                                            type: "DELETE_BIN"
                                        },
                                    ]}
                                />
                            </span>
                        </div>
                        <div className='w-full flex flex-col gap-4 rounded-lg border-2 border-[#DDE1EB]'>
                            <div className='w-full p-4 h-full'>
                                <Typography mt={2} mb={2} variant='h5'>
                                    {treeListData?.find((x) => x?.id_media === id_media)?.media_name || ""}
                                </Typography>
                                <span
                                    style={{
                                        display: 'grid',
                                        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                                        gap: 2
                                    }} className='flex-1 w-full h-full min-h-[10rem] flex p-5'>
                                    {media_files_local?.length === 0 && media_files?.length === 0 && id_media && (
                                        <span className='text-[#828282]'>
                                            {t("ไม่พบข้อมูล...")}
                                        </span>
                                    )}
                                    {media_files_local?.map((list, index) => {
                                        const isLoaded = loadedMap[list?.id_media_file];
                                        return <div
                                            key={index + 1} className='flex relative w-full justify-center items-center flex-wrap max-w-[auto]'>
                                            {isLoaded && (
                                                <span className='flex z-10 text-white justify-center items-center rounded-md absolute top-[-1rem] right-4'>
                                                    <IconButton sx={{ backgroundColor: "white" }} onClick={() => handleDeleteFileLocal(index)}>
                                                        <CloseIcon />
                                                    </IconButton>
                                                </span>
                                            )}
                                            <img
                                                onLoad={() =>
                                                    setLoadedMap(prev => ({ ...prev, [list?.id_media_file]: true }))
                                                }
                                                loading='lazy'
                                                className={`object-contain hover:opacity-45 cursor-pointer duration-500 ${isLoaded ? 'blur-0 opacity-100' : 'blur-md opacity-30'} transition-all`}
                                                width={200} height={"auto"}
                                                src={URL.createObjectURL(list)}
                                                alt={`list-${index + 1}`}
                                            />
                                        </div>
                                    })}
                                    {MasonryImageList(media_files.map((list) => {
                                        return {
                                            img: `${base_image_url}/${list?.media_file_path}${list?.media_file_name}`,
                                            title: list?.media_file_name,
                                            id_media_file: list?.id_media_file
                                        }
                                    }), loadedMap, setLoadedMap, checked, handleChangeSelected)}
                                    {/* {media_files?.map((list, index) => {
                                        const isLoaded = loadedMap[list?.id_media_file];
                                        return (
                                            <div key={list?.id_media}
                                                ref={ref}
                                                onClick={() => handleChangeSelected(list?.id_media_file)}
                                                className='flex relative w-full justify-center items-center flex-wrap max-w-[auto]'>
                                                {isLoaded && (
                                                    <span className='flex z-10 text-white justify-center items-center rounded-md absolute top-2 right-4'>
                                                        <CheckBoxCustom
                                                            label='เลือก'
                                                            checked={checked.includes(list?.id_media_file)}
                                                            setChecked={() => handleChangeSelected(list?.id_media_file)}
                                                        />
                                                    </span>
                                                )}
                                                {inView && (
                                                    <img
                                                        onLoad={() =>
                                                            setLoadedMap(prev => ({ ...prev, [list?.id_media_file]: true }))
                                                        }
                                                        loading='lazy'
                                                        className={`object-contain hover:opacity-45 cursor-pointer duration-500 ${isLoaded ? 'blur-0 opacity-100' : 'blur-md opacity-30'
                                                            } transition-all`}
                                                        width={200}
                                                        height={"auto"}
                                                        src={`${base_image_url}/${list?.media_file_path}${list?.media_file_name}`}
                                                        alt={`list-${index + 1}`}
                                                    />
                                                )}
                                            </div>

                                        )
                                    })} */}
                                </span>
                            </div>
                            <div className='w-full p-4 bg-[#F2F4F7]'>
                                <ContainerButton
                                    justifyContent='center'
                                    multiple_upload_file
                                    enable_image
                                    buttonData={[
                                        {
                                            seq: 1,
                                            key: "ADD2",
                                            label: t("บันทึก"),
                                            // hidden: media_files_local?.length === 0,
                                            hidden: media_files_local?.length === 0 || !checkPermit.isUpdate,
                                            buttonProps: {
                                                onClick: handleSubmitFileLocal
                                            },
                                            type: "ADD"
                                        },
                                        {
                                            seq: 2,
                                            key: "ADD",
                                            label: t("เพิ่ม"),
                                            hidden: !checkPermit.isCreated,
                                            buttonProps: {
                                                disabled: !id_media
                                            },
                                            onFileChange: (file) => handleChangeFileLocal(file),
                                            startIcon: <icons.add2 />,
                                            type: "ADD2"
                                        },
                                        {
                                            seq: 3,
                                            key: "DELETE_BIN",
                                            hidden: !checkPermit.isDelete,
                                            label: t("ลบ"),
                                            buttonProps: {
                                                disabled: checked.length === 0,
                                                onClick: handleDeleteMediaFile
                                            },
                                            type: "DELETE_BIN"
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                    </div>


                    {showModal !== "" && (
                        <ModalCustom
                            handleClose={handleCloseModal}
                            onClick={() => id_media ? handleSubmitMedia(id_media) : handleSubmitMedia()}
                            disabledSubmitButton={!formState.media_name}
                            open
                            title={showModal === 'EDIT' ? t('แก้ไขโฟลเดอร์') : t('เพิ่มโฟลเดอร์')}
                            subTitle={t('กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน')}
                            scrollBody
                            maxWidth='md'
                            form={
                                <div className='w-full'>
                                    <StateComponents
                                        otherProps={{ spacing: 2 }}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    heading: t("ชื่อโฟลเดอร์"),
                                                    placeholder: t("ระบุ"),
                                                    required: true,
                                                    value: formState.media_name,
                                                    onChange: (e) => setFormState((prev) => ({ ...prev, media_name: e.target.value })),
                                                }
                                            },
                                            {
                                                seq: 2,
                                                gridProps: {
                                                    xs: 12
                                                },
                                                type: "COMPONENT",
                                                fieldProps: {
                                                    element: (
                                                        <Box>
                                                            <Typography>{t("อยู่ภายใต้โฟลเดอร์")}</Typography>
                                                            <FolderTree
                                                                id_media={formState?.id_media_ref}
                                                                autoExpandToId={id_media}
                            
                                                                onClick={(id_media) => {
                                                                    setFormState((prev) => ({ ...prev, id_media_ref: prev?.id_media_ref === id_media ? null : id_media }))
                                                                }} data={treeListData} />
                                                        </Box>
                                                    )
                                                }
                                            }
                                        ]}
                                    />
                                </div>
                            }
                        />
                    )}
                </>
            }
        />
    )
}

export default ManageFile